// extracted by mini-css-extract-plugin
export default {"userForm":"userForm_userForm__mzuYP"};